<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Jp8NZ7/tc-custom/9781569478004.jpg?1704916897781" alt="This image is the cover for the book Gun Seller"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gun Seller
      </h1>
      <p class="bookDescription body article font2">
        <b>“A skillful mix of Bertie Wooster and James Bond . . . A thoroughgoing pleasure from beginning to end” (<i>Booklist</i>).</b><br/>  <br/> From the multitalented British actor, beloved for his roles on <i>Blackadder</i>, <i>Jeeves and Wooster</i>, and <i>House</i>, this is a spot-on spy spoof about hapless ex-soldier Thomas Lang, who is drawn unwittingly and unwillingly into the center of a dangerous plot of international terrorists, arms dealing, high-tech weapons, and CIA spooks.<br/>  <br/> “There is mystery, intrigue, sex, and violence, all of which Lang tosses off with sarcastic wit and remarkable poise. Laurie’s humor hits home. Although the subject is serious, even plausible, much of this comedy-thriller is laugh-out-loud funny.” —<i>Library Journal</i> <br/>  <br/> “Suspenseful, hilarious, witty, surprising, ridiculous, and pretty wonderful . . . A delightful novel.” —<i>The Washington Post Book World</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hugh Laurie
      </h2>
      
      <p class="authorDescription body article">Hugh Laurie has cowritten two comedy series for BBC television, <I>A Bit of Fry</I> and <I>Laurie</I>. He has also acted in the TV programs <I>Blackadder</I> and <I>Jeeves and Wooster</I> as well as in the American TV show <I>House</I>. He lives in London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Soho Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?29446618